import React from 'react'
import { Link } from 'react-router-dom'
import enabledHorizontalEventIcon from '../images/enabledHorizontalEventIcon.svg'
import EnabledHorizontalMenuIcon from './EnabledHorizontalMenuIcon'
import EnabledCheckHorizontalMenuIcon from './EnabledCheckHorizontalMenuIcon'
import EnabledOffenseHorizontalMenuIcon from './EnabledOffenseHorizontalMenuIcon'
import DisabledHorizontalMenuIcon from './DisabledHorizontalMenuIcon'
import disabledHorizontalEventIcon from '../images/disabledHorizontalEventIcon.svg'
import enabledCheckEventIcon from '../images/enabledCheckEventIcon.svg'
import disabledCheckEventIcon from '../images/disabledCheckEventIcon.svg'
import enabledCheckedEventIcon from '../images/enabledCheckedEventIcon.svg'
import disabledCheckedEventIcon from '../images/disabledCheckedEventIcon.svg'
import enabledOffenseIcon from '../images/enabledOffenseIcon.svg'
import disabledOffenseIcon from '../images/disabledOffenseIcon.svg'

class HorizontalEventMenuComponent extends React.Component {
  checkAllTab () {
    if (this.props.enabled === 'all') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledHorizontalEventIcon}
          label='Tout'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledHorizontalEventIcon}
        label='Tout'
      />
    )
  }

  checkCheckTab () {
    if (this.props.enabled === 'check') {
      return (
        <EnabledCheckHorizontalMenuIcon
          img={enabledCheckEventIcon}
          label='A vérifier'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledCheckEventIcon}
        label='A vérifier'
      />
    )
  }

  checkCheckedTab () {
    if (this.props.enabled === 'checked') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledCheckedEventIcon}
          label='Vérifié'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledCheckedEventIcon}
        label='Vérifié'
      />
    )
  }

  checkOffenseTab () {
    if (this.props.enabled === 'offense') {
      return (
        <EnabledOffenseHorizontalMenuIcon
          img={enabledOffenseIcon}
          label='Infraction'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledOffenseIcon}
        label='Infraction'
      />
    )
  }

  render () {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <Link style={styles.link} to='events'>
            {this.checkAllTab()}
          </Link>
          <Link style={styles.link} to='events-to-check'>
            {this.checkCheckTab()}
          </Link>
          <Link style={styles.link} to='checked-events'>
            {this.checkCheckedTab()}
          </Link>
          <Link style={styles.link} to='offenses'>
            {this.checkOffenseTab()}
          </Link>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%'
  },
  content: {
    top: '0px',
    margin: '0px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    marginLeft: '14px',
    paddingRight: '14px',
    height: '69px',
    borderColor: '#272C30'
  },
  icon: {
    marginTop: '1px',
    width: '38px',
    height: '40px'
  },
  enabledSection: {
    top: '0px',
    margin: '0px 0px 0px -3px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    width: '74px',
    height: '68px',
    float: 'left',
    borderColor: '#4880FF'
  },
  disabledSection: {
    width: '84px',
    height: '68px',
    float: 'left'
  },
  enabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#4880FF'
  },
  disabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#A6B9C8'
  },
  link: {
    textDecoration: 'none'
  }

}

export default HorizontalEventMenuComponent
